import { ChevronLeft, ChevronRight } from "lucide-react";
import type { RefObject } from "react";
export function CollectionPagination({ mobile, page, totalPages, busy, count, loadMoreRef, changePage, label, error }: {
  mobile: boolean; page: number; totalPages: number; busy: boolean; count: number;
  loadMoreRef: RefObject<HTMLDivElement | null>; changePage: (page: number) => void; label: string; error?: string | null;
}) {
  // The collection already has a loader/empty/error view. Only show the mobile
  // footer for populated results, and its spinner when appending another page.
  if (mobile && (!count || error || (busy && page === 1))) return null;
  if (mobile) return <div ref={loadMoreRef} className="mobile-load-more" aria-live="polite">
    {busy ? "Loading…" : page < totalPages
      ? <button type="button" className="button button--quiet button--small" disabled={!!error} onClick={() => changePage(page + 1)}>Scroll to load more</button>
      : count ? "All items loaded" : ""}
  </div>;
  if (totalPages <= 1) return null;
  return <nav className="cursor-pagination" aria-label={label}>
    <button className="button button--secondary button--small" type="button" disabled={busy || page <= 1} onClick={() => changePage(page - 1)}><ChevronLeft aria-hidden="true" size={16} /> Previous</button>
    <span>Page {page} of {totalPages}</span>
    <button className="button button--secondary button--small" type="button" disabled={busy || page >= totalPages} onClick={() => changePage(page + 1)}>Next <ChevronRight aria-hidden="true" size={16} /></button>
  </nav>;
}
